import { Action } from "../../../actions/actions";
import { VppsActionTypes } from "../actions/actionTypes";

export enum CreationModes {
    ADD_VPP = "ADD_VPP"
}

interface CreationModeState {
    mode: string | null;
}

export function creationMode(
    state: CreationModeState = { mode: null },
    action: Action
): CreationModeState {
    switch (action.type) {
        case VppsActionTypes.CREATION_MODE_CHANGE:
            return action.payload.mode;
        case VppsActionTypes.CREATE_VPP_RESET:
        case VppsActionTypes.CREATE_VPP_SUCCESS:
            return { mode: null };
        default:
            return state;
    }
}
